import intlTelInput from 'intl-tel-input';
import { addBlankDiv, barbaMarkup } from '../utils/func.js'
import { validateAddressActions } from '../components/validate-address.js'
import { cityStateLookup } from '../components/city-state-look-up.js'
import { emailValidation } from '../components/email-validation.js'

import {
	errorUpdateUI,
	frontendErrorToShow,
	placeOrder,
	placeOrderPost,
	postOnSuccess
} from './place-order.ts'

import { addGiftEditLink, giftCardfastPayment } from './gift-card.js'

import { initFastPaymentCheckoutUI } from './check-out-navigation.js'
import { checkoutScene } from './checkout-scene.js'
import '../utils/creditcard-detect.js'
import { loading } from '../components/loading.js'
import { isMobile, isPhone, isTablet } from '../utils/base-init.js'
import { trackMailingListOptInCheckBox } from './enter-email.js'
import '../components/autocompleteService.ts'
import '../components/save-info-to-cookie.js'
import initCheckoutTimer from '../components/init-checkout-timer.js'
// import { triggerMatomo } from '../components/trigger-matomo'
import splitName from '../utils/splitName.js'
import getStates, { findStateId } from '../utils/getStates.js'
import koWillCallAction from '../utils/koWillCallAction.js'
import dynamicDeliveryForm from '../utils/dynamicDeliveryForm.ts'
// import dynamicPaymentForm from '../utils/dynamicPaymentForm.ts'
import detectMobileWidth from '../utils/detectMobileWidth.js'
import { getCookie, setCookie } from '../utils/cookie.js'
import { saveGeolocation } from '../components/getGeolocation.js'
import orderDetailsTemplate from '../components/orderDetailsTemplate.ts'
import { suggestedMessage } from '../components/check-email.js'
import CustomTooltip from '../utils/custom-tooltip.ts'
import { addCustomTooltip } from '../utils/func.js';
import '../utils/cpf-validation.js'

// bellow js is from /application/modules/store/views/default/scripts/order/fast-payment.phtml
// export const anonymousEmail = 'anonymous@ticketingbox.com'
window.validAddress = true
export const dataCoreEncrypt = window.myvars.coreEncrypt
export const dataPolicyAlert = window.myvars.policyAlert
window.unfinishedSurvey = undefined
window.finishedSurvey = false
// export let resultOrderEid

let isMobileWidth
// window.confirmationUrl = void 0
// window.cleanUrl = void 0

export function paymentInfoSectionDisplay() {
	let paymentMethodId = $('input[name=paymentMethodId]').val()

	// no payment
	if ($('#paymentMethodId_0').val() == 0) {
		$('#credit-card-payment-wrapper').slideUp()
	} else if (!paymentMethodId) {
		// alert($('input:radio[name=paymentMethodId]'));
		// it will always fetch the first one
		$('input:radio[name=paymentMethodId]:first').attr('checked', 'checked')
		// $('.paymentMethodId').attr("checked", "checked");
	}

	// credit card
	if (paymentMethodId == 1 || paymentMethodId == 12) {
		orderPaymentCardOnClick()
		$('#bank-wire-wrapper').slideUp()
	} else {
		$('#credit-card-payment-wrapper').slideUp()
		if (paymentMethodId == 7) {
			$('#bank-wire-wrapper').slideDown()
		}
	}

	$('input:radio[name=paymentMethodId]').click(() => {
		paymentMethodId = $('input:radio[name=paymentMethodId]:checked').val()
		// 1=credit card, 3=cash, 4=check, 0=no payment, 7=bank wire
		if (paymentMethodId == 1 || paymentMethodId == 12) {
			$('#credit-card-payment-wrapper').slideDown()
		} else {
			$('#credit-card-payment-wrapper').slideUp()
		}

		if (paymentMethodId == 7) {
			$('#bank-wire-wrapper').slideDown()
		} else {
			$('#bank-wire-wrapper').slideUp()
		}
	})

	tabkeyTriggerPayment()

	// $('#creditCardNumber').focus();
}

export function tabkeyTriggerPayment() {
	$('input[name=email]').keydown((e) => {
		const code = e.keyCode || e.which

		if (code === 9) {
			e.preventDefault()
			$('#creditCardName').focus()
			// console.log('#creditCardName focus!')
		}
	})
}

export function updateMobileUi() {
	isMobileWidth = detectMobileWidth()
	if (isMobileWidth) {
		$('#select-mid-delivery-lg').remove()
		$('.order-return-exchange-policy-items')
			.clone()
			.appendTo('#order-return-exchange-policy-mobile-placeholder')
		$('#order-general-bottom-buttons').appendTo('.panel-banner')
	} else {
		$('#select-mid-delivery-sm').remove()
	}
}

export function billingInfoSectionDisplay() {
	const addressEidBilling = $('input[name=addressEidBilling]')
	// check same as billing first
	const sameAsShipping = $('#sameAsShipping').is(':checked')

	const billingBox = $('#billing-address-section')

	const billingDb = $('#billing-address-in-db-section')

	const creatNew = $('#create-new-address-billing').is(':checked')

	$('#billing-address-section').toggleClass('disabledElement', sameAsShipping)

	if (sameAsShipping && !creatNew) {
		billingBox.fadeOut();
		billingDb.fadeOut();
		addressEidBilling.attr('disabled', 'disabled')
	} else {
		addressEidBilling.removeAttr('disabled')
		billingDb.fadeIn()

		// if (window.myvars.addresses) {
			if (creatNew) {
				billingBox.fadeIn()
			} else {
				billingBox.fadeOut()
			}

			// console.log('addresses is true')
		// } else {
		// 	billingBox.fadeIn()
		// 	console.log('addresses is false')
		// 	console.log(document.querySelector('#billing-address-section'))
		// }
	}
}

function shippingInfoSectionDisplay() {
	const eid = $('#create-new-address').is(':checked')
	if (!eid) {
		$('#shipping-address-section').fadeOut()
	} else {
		$('#shipping-address-section').fadeIn()
	}
}

export function passwordDisplay() {
	// check same as billing first
	if ($('#create-acc-for-later').is(':checked')) {
		$('#password-section').fadeIn()
	} else {
		$('#password-section').fadeOut()
	}
}

export function surveyPopupOver() {
	if (!isPhone && !isTablet) {
		$('[data-toggle="tooltip"]').tooltip()
	}
}

export function orderPaymentFillUpAddress(eid) {
	if (eid && eid != dataCoreEncrypt) {
		const url = '/api/address/get-address-by-eid/eid/' + eid
		$.ajax({
			url,
			success(data) {
				let jsonResult
				if (typeof data === 'object') {
					jsonResult = data
				} else {
					jsonResult = eval('(' + data + ')')
				}

				$('#firstName').val(jsonResult.data.firstName)
				$('#lastName').val(jsonResult.data.lastName)
				$('#address1').val(jsonResult.data.address1)
				$('#address2').val(jsonResult.data.address2)
				$('#city').val(jsonResult.data.city)
				// $('#countryId').val(jsonResult.data.countryId);
				$('#zip').val(jsonResult.data.zip)
				$('#zip2').val(jsonResult.data.zip2)
				$('#stateId').val(jsonResult.data.stateId)
				// $('#stateId').val(jsonResult.data.stateId);
				$('#phone').val(jsonResult.data.phone)

				if (jsonResult.data.email) {
					$('#fp-email-top').val(jsonResult.data.email)
				}

				countryIdDefault = jsonResult.data.countryId
				stateIdDefault = jsonResult.data.stateId
				window.loadCountryList()
				window.loadStateListByCountry(countryIdDefault)
			}
		})
	}
}

function sameAsShippingOnCheck() {
	if ($('#same-as-shipping').attr('checked')) {
		// ajax load address
		orderPaymentFillUpAddress($('#shippingAddressEid').val())
	}
}

function orderPaymentCardOnClick() {
	const eid = $('input:radio[name=creditCardEid]:checked').val()

	if (eid && eid != dataCoreEncrypt) {
		orderPaymentDisableCardAddressFields()
	} else {
		orderPaymentEnableCardAddressFields()
		$('#same-as-shipping').attr('checked', 'checked')
		sameAsShippingOnCheck()
	}
}

function orderPaymentDisableCardAddressFields() {
	$('#order-fast-payment-credit-cart').fadeOut()
	$('#order-reenter-cvv').show()
}

function orderPaymentEnableCardAddressFields() {
	$('#order-reenter-cvv').hide()
	$('#order-fast-payment-credit-cart').fadeIn()
}

function fastPaymentUpdateDeliveryInfoOnclick() {
	const radios = $('.select-mid-delivery-item-sm').find('input')
	$.each(radios, (index, val) => {
		$(val).on('click', (event) => {
			if ($(val).prop('checked')) {
				$(val).parents('.select-mid-delivery-item-sm').addClass('active')
				$('.select-mid-delivery-item-sm')
					.find('input')
					.not(val)
					.parents('.select-mid-delivery-item-sm')
					.removeClass('active')
			} else {
				$(val).parents('.select-mid-delivery-item-sm').removeClass('active')
			}
			/* Act on the event */
		})
	})
}

export function fastPaymentUpdateDeliveryInfoMobile(deliveryType) {
	const errorBlock = document.querySelector('#mobile-delivery-error')
	if (errorBlock) errorBlock.innerHTML = ''

	$.post('/store/order/fast-payment-update-delivery-info', {
		midDelivery: $('input[name=midDelivery]:checked').val()
	}).done((data) => {
		frontendFastPaymentLoadOrderSummary()
		if (window.koStore) {
			if (deliveryType) {
				window.deliveryMethod = deliveryType
				koWillCallAction(deliveryType)
			}
		} else {
			window.deliveryMethod = $('input[name=midDelivery]:checked').attr(
				'data-delivery-method'
			)
			dynamicDeliveryForm(window.deliveryMethod)
		}
	})
}

function fastPaymentUpdateDeliveryInfo(selectDom) {
	$.each($('#select-mid-delivery option:checked'), function () {
		const description = $(this).attr('data-description')
		$('#delivery-description').html(description)
	})

	$.post('/store/order/fast-payment-update-delivery-info', {
		midDelivery: $('#select-mid-delivery option:checked').val()
	}).done((data) => {
		frontendFastPaymentLoadOrderSummary()

		if (window.koStore) {
			if (selectDom) {
				window.deliveryMethod = selectDom
					.querySelector('option:checked')
					.getAttribute('data-delivery-type')
				koWillCallAction(window.deliveryMethod)
			}
		} else if (selectDom) {
			window.deliveryMethod = selectDom
				.querySelector('option:checked')
				.getAttribute('data-delivery-type')
			dynamicDeliveryForm(window.deliveryMethod)
		}
	})
}

function frontendAjaxLoadPayment() {
	const paymentMethodId = $('#paymentMethodId').val()
	const deliveryType = isMobile
		? $('input[name=midDelivery]:checked').attr('data-delivery-method')
		: $('#select-mid-delivery :selected').attr('data-delivery-type')

	// pass forward billing address related values
	const urlParams = new URLSearchParams(window.location.search)

	let billingParams = ''

	if (urlParams.get('firstNameBilling')) {
		billingParams += '/firstNameBilling/' + urlParams.get('firstNameBilling')
	} else if ($('#firstNameBilling').val()) {
		billingParams += '/firstNameBilling/' + $('#firstNameBilling').val()
	}

	if (urlParams.get('lastNameBilling')) {
		billingParams += '/lastNameBilling/' + urlParams.get('lastNameBilling')
	} else if ($('#lastNameBilling').val()) {
		billingParams += '/lastNameBilling/' + $('#lastNameBilling').val()
	}

	if (urlParams.get('firstNameKatakanaBilling')) {
		billingParams +=
			'/firstNameKatakanaBilling/' + urlParams.get('firstNameKatakanaBilling')
	} else if ($('#firstNameKatakanaBilling').val()) {
		billingParams +=
			'/firstNameKatakanaBilling/' + $('#firstNameKatakanaBilling').val()
	}

	if (urlParams.get('lastNameKatakanaBilling')) {
		billingParams +=
			'/lastNameKatakanaBilling/' + urlParams.get('lastNameKatakanaBilling')
	} else if ($('#lastNameKatakanaBilling').val()) {
		billingParams +=
			'/lastNameKatakanaBilling/' + $('#lastNameKatakanaBilling').val()
	}

	if (urlParams.get('phoneBilling')) {
		billingParams += '/phoneBilling/' + urlParams.get('phoneBilling')
	} else if ($('#phoneBilling').val()) {
		billingParams += '/phoneBilling/' + $('#phoneBilling').val()
	}

	if (urlParams.get('phoneCountryCodeBilling')) {
		billingParams += '/phoneCountryCodeBilling/' + urlParams.get('phoneCountryCodeBilling')
	} else if (window.phoneCountryCodeBilling) {
		billingParams += '/phoneCountryCodeBilling/' + window.phoneCountryCodeBilling
	}

	if (urlParams.get('address1Billing')) {
		billingParams += '/address1Billing/' + urlParams.get('address1Billing')
	} else if ($('#address1Billing').val()) {
		billingParams += '/address1Billing/' + $('#address1Billing').val()
	}

	if (urlParams.get('address2Billing')) {
		billingParams += '/address2Billing/' + urlParams.get('address2Billing')
	} else if ($('#address2Billing').val()) {
		billingParams += '/address2Billing/' + $('#address2Billing').val()
	}

	if (urlParams.get('cityBilling')) {
		billingParams += '/cityBilling/' + urlParams.get('cityBilling')
	} else if ($('#cityBilling').val()) {
		billingParams += '/cityBilling/' + $('#cityBilling').val()
	}

	if (urlParams.get('stateIdBilling')) {
		billingParams += '/stateIdBilling/' + urlParams.get('stateIdBilling')
	} else if ($('#stateIdBilling').val()) {
		billingParams += '/stateIdBilling/' + $('#stateIdBilling').val()
	}

	if (urlParams.get('countryIdBilling')) {
		billingParams += '/countryIdBilling/' + urlParams.get('countryIdBilling')
	} else if ($('#countryIdBilling').val()) {
		billingParams += '/countryIdBilling/' + $('#countryIdBilling').val()
	}

	if (urlParams.get('zipBilling')) {
		billingParams += '/zipBilling/' + urlParams.get('zipBilling')
	} else if ($('#zipBilling').val()) {
		billingParams += '/zipBilling/' + $('#zipBilling').val()
	}

	if (urlParams.get('zip2Billing')) {
		billingParams += '/zip2Billing/' + urlParams.get('zip2Billing')
	} else if ($('#zip2Billing').val()) {
		billingParams += '/zip2Billing/' + $('#zip2Billing').val()
	}

	if (urlParams.get('emailBilling')) {
		billingParams += '/emailBilling/' + urlParams.get('emailBilling').replace(/\+/g, '%2B')
	} else if ($('#emailBilling').val()) {
		billingParams += '/emailBilling/' + $('#emailBilling').val().replace(/\+/g, '%2B')
	}

	if (urlParams.get('addressEidBilling')) {
		billingParams += '/addressEidBilling/' + urlParams.get('addressEidBilling')
	} else if ($('#addressEidBilling').val()) {
		billingParams += '/addressEidBilling/' + $('#addressEidBilling').val()
	}

	const additionalFields = [
		'paypayLastName',
		'paypayFirstName',
		'paypayPhone',
		'paypayEmail',
		'bankTransferLastName',
		'bankTransferFirstName',
		'bankTransferPhone',
		'bankTransferEmail',
		'konbiniLastName',
		'konbiniFirstName',
		'konbiniPhone',
		'konbiniEmail',
	]
	additionalFields.forEach((field) => {
		if (urlParams.get(field)) {
			billingParams += '/' + field + '/' + urlParams.get(field).replace(/\+/g, '%2B')
		} else if ($('#' + field).val()) {
			billingParams += '/' + field + '/' + $('#' + field).val().replace(/\+/g, '%2B')
		}
	})

	let sameAsShippingParams = ''
	// check for if patron has filled in billing first name -> this is so that if they have started on the billing address form, we dont touch its state
	if ($('#firstNameBilling').val()) {
		// if (($('#sameAsShipping').val() == "on")
		sameAsShippingParams = '/sameAsShipping/0'
	} else {
		// check for delivery method
		if (deliveryType == 'shipping') {
		} else {
			sameAsShippingParams = '/sameAsShipping/0'
		} // e.g. if delivery is will call or eticket
	}

	return new Promise((resolve, reject) => {
		const ajaxUrl =
			'/store/order/fast-payment-ajax-load-payment-section' +
			'/paymentMethodId/' +
			paymentMethodId +
			billingParams +
			sameAsShippingParams
		$.ajax({
			url: ajaxUrl,
			type: 'GET',
			success: (result) => {
				$('.fast-payment-content-ajax').html(result)
				onUseShippingForBillingChecked()
				resolve()
			},
			fail: (error) => {
				console.info(`Error in frontendAjaxLoadPayment(): ${error}`)
				reject(error)
			}
		})
	})
}

async function frontendAjaxLoadSummary() {
	return new Promise((resolve, reject) => {
		const ajaxUrl =
			'/store/order/ajax-load-frontend-order-summary/fast-payment/1'

		if (giftCardCheckout || !detectMobileWidth()) {
			$.ajax({
				url: ajaxUrl,
				type: 'GET',
				success: (payload) => {
					const finalTotal = $(payload).find('.final-total-line-value')
					console.info(`finalTotal: ${finalTotal}`)
					$('#block-order-summary').html(payload)
					$('#fp-bottom-info .fp-final-total-value').html($(finalTotal).html())

					if (giftCardCheckout) {
						const orderDetails = $(payload)
							.find('#gift-card-redeemable-events')
							.html()
						console.info('giftCardCheckout success frontendAjaxLoadSummary()')
						resolve(orderDetails)
					} else {
						// console.info('resolve in frontendAjaxLoadSummary()')
						addCustomTooltip();
						resolve()
					}
				},
				fail: (error) => {
					console.info(`Error in frontendAjaxLoadSummary(): ${error}`)
					reject(error)
				}
			})
		} else {
			$.ajax({
				url: '/store/order/ajax-load-frontend-order-summary/fast-payment/1/api/1',
				type: 'GET',
				success: (data) => {
					// console.debug(data)
					resolve(data)
				},
				fail: (error) => {
					reject(error)
				}
			})
		}
	})
}

async function frontendFastPaymentLoadOrderSummary() {
	try {
		await $('#block-order-summary').html(loading(1.6, 1.6))
		const orderDetails = await frontendAjaxLoadSummary()

		if (giftCardCheckout) {

			cleanProgressbar(orderDetails)
			addGiftEditLink('#giftcard-edit-link-2')
		} else {
			const placeholder = document.querySelector('#root-order-summary')
			if (placeholder && detectMobileWidth()) {
				console.debug('orderDetails')
				// console.debug(orderDetails.amount)
				// console.debug(typeof orderDetails)
				placeholder.innerHTML = orderDetailsTemplate(JSON.parse(orderDetails))
				window.tooltip.attachAll();
			}

			if (detectMobileWidth()) {
				const totalDiv = document.querySelector('#fp-final-total')
				if (totalDiv) {
					const order = JSON.parse(orderDetails)
					totalDiv.innerHTML = window.Locale.formatCurrency(order.amount.meta.finalTotal, window.myvars.langCode)
				}
			}
		}

		// if (!NotLoadPayment) await frontendAjaxLoadPayment()
		await frontendAjaxLoadPayment()

		checkoutScene()
	} catch (error) {
		console.error(
			`Error on frontendFastPaymentLoadOrderSummary async function: ${error}`
		)
	}
}

export function cleanProgressbar(orderDetails) {
	$('#order-detail-desk-placeholder').html(orderDetails)
}

// function billingCityStateLookup() {
// 	setTimeout(() => {
// 		$('#zipBilling, #countryIdBilling').change(() => {
// 			cityStateLookup(
// 				$('#zipBilling').val().trim(),
// 				$('#countryIdBilling option:selected').text(),
// 				'cityBilling',
// 				'stateIdBilling'
// 			)
// 		})
// 	}, 1000)
// }

export function fastpaymentCatchEmail(emailTop) {
	if (emailTop) {
		emailTop.addEventListener('blur', emailSyncFn(emailTop, true))
		emailTop.addEventListener('keyup', emailSyncFn())
	}
}

let messageIsHiddenInitial = true
let billingMessageIsHiddenInitial = true
window.emailHasBeenChanged = false
window.emailBillingHasBeenChanged = false

function emailSyncFn(emailTop, onBlur) {
	return (e) => {
		if (onBlur && emailTop) {
			suggestedMessage()
			if (emailTop.value === '') {
				return false
			}
		}

		if (!window.emailHasBeenChanged) {
			$('#email').val(e.target.value)
		}

		if (!window.emailBillingHasBeenChanged) {
			console.log('test emailSyncFn' + e.target.value)
			$('#emailBilling').val(e.target.value)
			$('#fp-bottom-email').html(e.target.value)
			$('.emailBillingValue').html(e.target.value)
		}

		$('.email__value').html(e.target.value)
		const message = document.querySelector('.emailField___message')
		const messageBilling = document.querySelector(
			'.emailField__Billing_message'
		)

		if (
			!isMobile &&
			messageIsHiddenInitial &&
			message &&
			message.style.display === 'none'
		) {
			message.style.display = 'block'
			messageIsHiddenInitial = false
		}

		if (
			!isMobile &&
			billingMessageIsHiddenInitial &&
			messageBilling &&
			messageBilling.style.display === 'none'
		) {
			messageBilling.style.display = 'block'
			billingMessageIsHiddenInitial = false
		}

		console.debug('emailSyncFn')
	}
}

function emailBillingSyncFn() {
	const emailBilling = document.querySelector('#emailBilling')
	const buttonTextEmailBilling = document.querySelector('#fp-bottom-email')
	if (emailBilling && buttonTextEmailBilling) {
		emailBilling.addEventListener('change', (e) => {
			buttonTextEmailBilling.innerHTML = e.target.value
			window.emailBillingHasBeenChanged = true
		})
	}
}

function emailBillingSync() {
	const emailBilling = document.querySelector('#emailBilling')
	const emailShipping = document.querySelector('#email')
	const buttonTextEmailBilling = document.querySelector('#fp-bottom-email')
	if (emailBilling && emailShipping) {
		emailShipping.addEventListener('change', (e) => {
			if (!window.emailBillingHasBeenChanged) {
				emailBilling.value = e.target.value
				if (buttonTextEmailBilling) buttonTextEmailBilling.innerHTML = e.target.value
			}
		})
	}
}

function emailBillingSyncText() {
	const emailBilling = document.querySelector('#emailBilling')
	const emailBillingValue = document.querySelector('.emailBillingValue')
	const topEmail = document.querySelector('#fp-email-top')
	if (emailBillingValue && topEmail && emailBilling) {
		emailBillingValue.innerHTML = topEmail.value
		emailBilling.value = topEmail.value
	}
}

function hidePromptEmail(className) {
	const emailField = document.querySelector(`.${className}`)
	const emailMessage = document.querySelector(`.${className}_message`)
	if (emailField) {
		emailField.style.display = 'block'
		emailMessage.style.display = 'none'
		emailField.children[0].focus()
		emailField.children[0].select()
		// emailField.children[0].value = ''
	}

	if (className === 'emailField__') window.emailHasBeenChanged = true
	if (className === 'emailField__Billing') {
		window.emailBillingHasBeenChanged = true
		if (window.myvars.enableEmailValidation) {
			document.querySelector('#emailBilling').addEventListener('blur', (e) => {
				const emailBilling = e.target.value.trim().toLowerCase()
				if ($('#emailBilling').valid() && emailBilling !== $('#fp-email-top').val().trim().toLowerCase()) {
					emailValidation(emailBilling)
				}
			})
		}
	}
}

export function getEmailFromCookie(emailInput, htmlDiv) {
	const email = getCookie('savedEmail')
	if (email) {
		$(emailInput).val(email)
		if (htmlDiv) $(htmlDiv).html(email)
	}
}

export const FastPayment = {
	namespace: 'fastPayment',
	beforeEnter: () => {
		barbaMarkup('fastPayment')
		giftCardfastPayment()
		updateMobileUi()

		paymentInfoSectionDisplay()
		validateAddressActions()
		// update delivery info
		if (window.enableExitIntend) window.exitIntent()

		surveyPopupOver()
		// ajaxLoadMenu()
		if (window.myvars.addresses) shippingInfoSectionDisplay()

		// passwordDisplay();
		billingInfoSectionDisplay()

		initFastPaymentCheckoutUI(window)
		fastPaymentUpdateDeliveryInfoOnclick()
		// fastPaymentUpdateDeliveryInfo(document.querySelector('#select-mid-delivery'))

		setCookie('currentPage', 'Checkout', 1, '')
		// return checkoutScript.init()
	},

	afterEnter: () => {
		getEmailFromCookie('#email,#fp-email-top,#emailBilling', '#fp-bottom-email')
		// cloneSurvey()
		if (isMobile) {
			fastPaymentUpdateDeliveryInfoMobile(
				document.querySelector('#select-mid-delivery')
			)
		}

		fastPaymentUpdateDeliveryInfo(
			document.querySelector('#select-mid-delivery')
		)

		setTimeout(() => {
			trackMailingListOptInCheckBox()
		}, 3000)
		const countDownSeconds = $('#checkout-countdown-seconds').attr(
			'data-countdown'
		)
		const { alertMessage } = window.myvars
		initCheckoutTimer(countDownSeconds, alertMessage, false)
		// triggerMatomo(window.myvars.scheduleEid, 'fastPayment')

		saveGeolocation()
		window.CustomTooltip = CustomTooltip;
	}
}

// window.addEventListener('resize', () => {
// 	updateMobileUi()
// 	paymentInfoSectionDisplay()
// 	initFastPaymentCheckoutUI(window)
// 	console.debug('resize')
// })


window.paymentInfoSectionDisplay = paymentInfoSectionDisplay
window.tabkeyTriggerPayment = tabkeyTriggerPayment
window.billingInfoSectionDisplay = billingInfoSectionDisplay
window.shippingInfoSectionDisplay = shippingInfoSectionDisplay
window.fastPaymentUpdateDeliveryInfoMobile = fastPaymentUpdateDeliveryInfoMobile
window.passwordDisplay = passwordDisplay

window.cleanProgressbar = cleanProgressbar
window.updateMobileUi = updateMobileUi
window.surveyPopupOver = surveyPopupOver

// window.orderHelperLoadOrderSummary = orderHelperLoadOrderSummary
window.fastPaymentUpdateDeliveryInfo = fastPaymentUpdateDeliveryInfo

window.orderPaymentFillUpAddress = orderPaymentFillUpAddress
window.sameAsShippingOnCheck = sameAsShippingOnCheck
window.orderPaymentDisableCardAddressFields =
	orderPaymentDisableCardAddressFields
window.orderPaymentEnableCardAddressFields = orderPaymentEnableCardAddressFields
window.orderPaymentCardOnClick = orderPaymentCardOnClick
window.frontendFastPaymentLoadOrderSummary = frontendFastPaymentLoadOrderSummary
// window.updateOrderPaymentSection = updateOrderPaymentSection
// window.billingCityStateLookup = billingCityStateLookup

window.frontendErrorToShow = frontendErrorToShow
window.errorUpdateUI = errorUpdateUI
window.postOnSuccess = postOnSuccess
window.placeOrderPost = placeOrderPost
window.placeOrder = placeOrder
window.getEmailFromCookie = getEmailFromCookie
window.fastpaymentCatchEmail = fastpaymentCatchEmail
window.splitName = splitName
window.getStates = getStates
window.findStateId = findStateId
window.cityStateLookup = cityStateLookup
window.emailBillingSyncFn = emailBillingSyncFn
window.hidePromptEmail = hidePromptEmail
window.emailBillingSyncText = emailBillingSyncText
window.emailBillingSync = emailBillingSync
